import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import { BankReconciliationRow } from "../bankReconciliationViewConfig";

export const AccountNameCell = ({
    row,
}: CellContext<ViewTableFeatures, BankReconciliationRow, unknown>) => {
    const financialAccount = row.original.financialAccount;
    const reconciliation = row.original.bankReconciliation;
    const parentRow = row.getParentRow();
    const indexInParent =
        (parentRow &&
            parentRow.original.reconciliations?.indexOf(row.original)) ??
        0;

    return (
        <ViewTableCell>
            {reconciliation ? (
                `#${indexInParent + 1}`
            ) : (
                <AccountCard
                    account={financialAccount}
                    numberInName
                    showType={false}
                    iconSize="xs"
                />
            )}
        </ViewTableCell>
    );
};
